import generalApi from '@/api/general-api'
import partesApi from '../../api/partes-api'
import router from '../../router'

const state = {
  items: [],
  totalItems: 0,
  chargeList: 0,
  selectStatus: [],
}

const mutations = {
  setItems(state, val) {
    state.items = val
  },
  setTotalItems(state, val) {
    state.totalItems = val
  },
  setChargeList(state, val) {
    state.chargeList = val
  },
  setSelectStatus(state, val) {
    state.selectStatus = val
  },
}

const actions = {
  getList({ commit }, {
    page, per_page, search = '', timestamp = '', user = '', client = '', department_id = '', attendance_status = '', orderBy = '',
  }) {
    commit('app/loading', true, { root: true })
    partesApi.getList(page, per_page, search, timestamp, user, client, department_id, attendance_status, orderBy)
      .then(
        response => {
          commit('setItems', response.data.data)
          commit('setTotalItems', response.data.meta.total[1])
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al obtener el listado de partes de trabajo.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  async generateMonthly({ commit }, {
    timestamp = '',
    client_id = '',
  }) {
    commit('app/loading', true, { root: true })
    await partesApi.generateMonthly(timestamp, client_id)
      .then(
        response => {
          commit('notifications', { title: 'Informes mensuales generados correctamente.', variant: 'success' }, { root: true })
          commit('setShowNotifications', true, { root: true })
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al generar informes mensuales.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  edit({ commit }, { user }) {
    commit('app/loading', true, { root: true })
    partesApi.edit(user)
      .then(
        () => {
          commit('notifications', { title: 'Jornada actualizada con éxito.', variant: 'success' }, { root: true })
          commit('setShowNotifications', true, { root: true })
          commit('setChargeList', 1)
          commit('app/loading', false, { root: true })
        },
        () => {
          commit('app/loading', false, { root: true })
          commit('notifications', { title: 'Error al actualizar la jornada.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
  async getSelectStatus({ commit }) {
    await generalApi.status('journeyday')
      .then(
        response => {
          commit('setSelectStatus', response.data)
        },
        () => {
          commit('notifications', { title: 'Error en la carga de estados.', variant: 'danger' }, { root: true })
          commit('setShowNotifications', true, { root: true })
        },
      )
  },
}

const getters = {
  getItems: state => state.items,
  getTotalItems: state => state.totalItems,
  getChargeList: state => state.chargeList,
  getSelectStatus: state => state.selectStatus,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
